import React from 'react'
import Logo from '../images/shoutbase-logo.svg'

class TeamModalNav extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { team } = this.props
        return (
            <div className="team-modal-nav">
                <div className="nav-items">
                    <img src={Logo} alt="Shoutbase Logo" />
                    <span className="team-name">{team.name}</span>
                    <span className="chevron"><i className="fa fa-chevron-right"></i></span>
                    <span>Members</span>
                </div>
            </div>
        )
    }
}

export default TeamModalNav


// WEBPACK FOOTER //
// ./src/components/team_modal_nav.jsx